import { Component, HostListener, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/services/invoice.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { CouponsService } from 'src/app/services/coupons.service';
import { CouponCalculatorService } from './coupon-calculator.service';
import { debounceTime, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';




@Component({
  selector: 'app-workshop-jobcard-add-coupon',
  templateUrl: './workshop-jobcard-add-coupon.component.html',
  styleUrls: ['./workshop-jobcard-add-coupon.component.scss']
})
export class WorkshopJobcardAddCouponComponent {

  @Input() public jobcard: any = {};
  @Input() public partnerData: any = {};
  @Input() public vatInclusive: boolean = true;

  public couponCode: string = '';
  public couponCodeError: string = '';
  public couponCodeValid: boolean = false;
  public couponResponse: any = null;

  private searchSubject = new Subject<string>();

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private couponsService: CouponsService,
    private translate: TranslateService,
    private couponCalculatorService: CouponCalculatorService
  ) { }

  ngOnInit() {

    this.searchSubject
      .pipe(debounceTime(1000))
      .subscribe((couponCode) => {
        if (couponCode.length > 2) {
          this.validateCoponCode();
        }
      });
  }

  applyCoupon() {
    if (this.couponCode && this.couponCode.length > 0 && this.couponCodeValid && this.couponResponse?.coupon?.id) {

      this.jobcard.quote.couponResponse = this.couponResponse;
      this.jobcard.quote.couponCode = this.couponCode;
      this.jobcard.quote.couponDiscountType = this.couponResponse.coupon.type;
      this.jobcard.quote.couponDiscount = this.couponResponse.coupon.type === "PERCENT" ? this.couponResponse.coupon.percentValue : this.couponResponse.coupon.fixedValue;

      this.couponCalculatorService.applyCoupon(this.jobcard.quote.couponResponse, this.jobcard, this.vatInclusive);

      this.activeModal.close({});
    }
  }


  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.applyCoupon();
  }

  onCouponCodeChange() {
    this.searchSubject.next(this.couponCode);
  }

  validateCoponCode() {

    var data = {
      PartnerID: this.helpersService.getPartnerId(),
      CouponCode: this.couponCode,
      UserID: this.jobcard.customer?.userID || this.jobcard.customer?.ID || 0,
      SelectedServiceTypes: this.jobcard.selectedServiceTypes && this.jobcard.selectedServiceTypes.length > 0 ? this.jobcard.selectedServiceTypes.map(x => { return x.serviceTypeID }) : []
    }

    this.couponsService.validateCouponCodeV2(data).subscribe((response: any) => {
      console.log(response);
      this.couponCodeValid = true;
      this.couponCodeError = '';
      this.couponResponse = response;
    }, err => {
      this.couponCodeValid = false;
      this.couponResponse = '';
      if (err.status === 400) {
        if (err.error && err.error.message) {
          this.couponCodeError = this.translate.instant(err.error.message);
        }
      } else if (err.status === 404) {
        if (err.error && err.error.message) {
          //this.couponCodeError = this.translate.instant(err.error.message);
        }
      }
    });

  }

}
